var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_43766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 7.60856 26.3851 0 17 0C7.60856 0 0 7.60856 0 17C0 25.483 6.21456 32.5168 14.3438 33.7907V21.9151H10.0268V17.0011H14.3438V13.2536C14.3438 8.99406 16.8778 6.64169 20.7623 6.64169C22.6228 6.64169 24.5703 6.97319 24.5703 6.97319V11.1562H22.423C20.315 11.1562 19.6562 12.4684 19.6562 13.8125V17H24.3706L23.613 21.9141H19.6562V33.7896C27.7791 32.5157 34 25.4819 34 16.9989V17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_43766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.55d68c05a9e19d6128a711e5520dd3d6.svg";
export { ForwardRef as ReactComponent };